import { render, staticRenderFns } from "./content-sheet-ayuda.vue?vue&type=template&id=21bca61c&scoped=true&"
import script from "./content-sheet-ayuda.vue?vue&type=script&lang=js&"
export * from "./content-sheet-ayuda.vue?vue&type=script&lang=js&"
import style0 from "./content-sheet-ayuda.vue?vue&type=style&index=0&id=21bca61c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bca61c",
  null
  
)

export default component.exports